module.exports = __webpack_public_path__ + "img/0.b0bfec1c.jpg";